export const ATTRIBSLIST = "ATTRIBSLIST"
export const ATTRIBSCREATE = "ATTRIBSCREATE"
export const ATTRIBSUPDATE = "ATTRIBSUPDATE"
export const ATTRIBSDETAILS = "ATTRIBSDETAILS"
export const ATTRIBSSTATUS = "ATTRIBSSTATUS"
